<template>
  <div>
    <FormPaymentReceiptAccount
      v-if="showForm"
      :title-form="objectFormInsert.titleForm"
      :combo-payment="comboFormaPagamento"
      :combo-type="comboTipoPagamento"
      :combo-situation="comboSituacao"
      :combo-account="comboContas"
      :object-edit="objectAssociado"
      @cancelar="cancelar"
      @save="save"
    />
    <div v-else>
      <b-row class="mb-1 mt-1">
        <b-col cols="12">
          <app-collapse type="margin">
            <app-collapse-item title="Configuração de Pagamento">
              <FormAssociantePaymentConfigVue />
            </app-collapse-item>
            <app-collapse-item title="Faixa de Contribuição">
              <FormAssocianteFaixaContribuicaoVue />
            </app-collapse-item>
          </app-collapse>
        </b-col>
      </b-row>

      <!-- Filtros (Mirroring TransacoesFinanceiras.vue) -->
      <b-card v-if="!showForm" class="mb-1 shadow-sm border-0">
        <b-row>
          <b-col cols="12" md="4">
            <b-form-group label="Buscar" label-for="filtro-campo">
              <b-form-input
                id="filtro-campo"
                v-model="filter.campo"
                type="text"
                placeholder="Descrição..."
                @input="handleSearch"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2">
            <b-form-group label="Filtrar por" label-for="filtro-tipo-data">
              <b-form-select
                id="filtro-tipo-data"
                v-model="filter.tipoData"
                :options="opcoesTipoData"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2">
            <b-form-group label="Data Início" label-for="filtro-data-inicio">
              <b-form-input
                id="filtro-data-inicio"
                v-model="filter.dataInicio"
                type="date"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2">
            <b-form-group label="Data Fim" label-for="filtro-data-fim">
              <b-form-input
                id="filtro-data-fim"
                v-model="filter.dataFinal"
                type="date"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="2" class="d-flex align-items-end mb-1">
            <b-button variant="primary" block @click="aplicarFiltro">
              <feather-icon icon="SearchIcon" size="14" class="mr-50" />
              Filtrar
            </b-button>
          </b-col>
          
          <b-col cols="12" md="4">
            <b-form-group label="Tipo de Lançamento" label-for="filtro-tipo">
              <b-form-select
                id="filtro-tipo"
                v-model="filter.tipoTransacao"
                :options="opcoestipoTransacao"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Situação" label-for="filtro-situacao">
              <b-form-select
                id="filtro-situacao"
                v-model="filter.situacao"
                :options="opcoesSituacao"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Conta Bancária" label-for="filtro-conta">
              <b-form-select
                id="filtro-conta"
                v-model="filter.contaId"
                :options="comboContas"
                value-field="id"
                text-field="descricao"
              >
                <template #first>
                  <b-form-select-option :value="null">Todas as Contas</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <!-- Tabela (Mirroring TransacoesFinanceiras.vue) -->
      <b-card no-body class="shadow-sm border-0 mb-2">
        <b-card-header class="pb-0">
          <b-card-title class="font-medium-3">
            <feather-icon icon="ListIcon" class="mr-50 text-info" />
            Lançamentos Financeiros
          </b-card-title>
        </b-card-header>
        <b-card-body>
          <div class="d-flex justify-content-between align-items-center my-1">
            <b-button
              v-if="verificarPermissao('ROLE_FINAN_INSERIR')"
              variant="primary"
              class="btn-icon-left"
              @click="add()"
            >
              <feather-icon icon="PlusIcon" />
              <span class="align-middle">Incluir Lançamento</span>
            </b-button>
          </div>

          <vue-good-table
            mode="remote"
            :columns="columns"
            :rows="listaFinanceira"
            :rtl="direction"
            :is-loading.sync="isLoading"
            :pagination-options="{
              enabled: true,
              perPage: tableConfigs.size
            }"
            :total-rows="tableConfigs.totalElements"
            @on-sort-change="onSortChange"
          >
            <template slot="table-row" slot-scope="props">
              <!-- Mirroring badges and templates from TransacoesFinanceiras.vue -->
              <span v-if="props.column.field === 'situacao'">
                <b-badge :variant="getSituacaoBadgeVariant(props.row.situacao)" pill>
                  {{ getSituacaoLabel(props.row.situacao) }}
                </b-badge>
              </span>

              <span v-else-if="props.column.field === 'tipoBadge'">
                <b-badge :variant="getTipoBadgeVariant(props.row)" pill>
                  {{ getTipoLabel(props.row) }}
                </b-badge>
              </span>

              <span v-else-if="props.column.field === 'valorTotal'">
                {{ formatCurrencyBrazil(props.row.valorTotal) }}
              </span>

              <span v-else-if="props.column.field === 'action'">
                <span class="d-flex align-items-center gap-50">
                  <b-button
                    v-b-tooltip.hover
                    title="Editar"
                    variant="flat-secondary"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="editFinanceiro(props.row)"
                  >
                    <feather-icon icon="Edit2Icon" size="16" />
                  </b-button>
                  <b-button
                    v-if="verificarPermissao('ROLE_FINAN_DELETAR')"
                    v-b-tooltip.hover
                    title="Excluir"
                    variant="flat-danger"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="remove(props.row)"
                  >
                    <feather-icon icon="TrashIcon" size="16" />
                  </b-button>
                </span>
              </span>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap">Exibindo</span>
                  <b-form-select
                    v-model="tableConfigs.size"
                    :options="[10, 20, 50]"
                    class="mx-1"
                    @input="handleChangePage(1)"
                  />
                  <span class="text-nowrap">de {{ tableConfigs.totalElements }} registros</span>
                </div>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="tableConfigs.totalElements"
                  :per-page="tableConfigs.size"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @change="handleChangePage"
                >
                  <template #prev-text><feather-icon icon="ChevronLeftIcon" size="18" /></template>
                  <template #next-text><feather-icon icon="ChevronRightIcon" size="18" /></template>
                </b-pagination>
              </div>
            </template>
          </vue-good-table>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {
  BButton,
  BDropdown,
  BDropdownItem,
  BFormSelect,
  BPagination,
  BCol,
  BRow,
  BCard,
  BCardBody,
  BCollapse,
  BFormGroup,
  BFormInput,
  BBadge,
  VBTooltip
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import FormPaymentReceiptAccount from '@/layouts/components/FormPaymentReceiptAccount.vue'
import FilterCompoents from '@/layouts/components/FilterComponents.vue'
import FormAssocianteFaixaContribuicaoVue from '../personal/FormAssocianteFaixaContribuicao.vue'
import FormAssociantePaymentConfigVue from '../personal/FormAssociantePaymentConfig.vue'
import mixinsGlobal from '@/mixins'
import { BCardTitle, BCardHeader, BFormSelectOption } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import _ from 'lodash'

export default {
  components: {
    BButton,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BPagination,
    BCol,
    BRow,
    BCard,
    BCardBody,
    BCollapse,
    BCardTitle,
    BCardHeader,
    VueGoodTable,
    FormPaymentReceiptAccount,
    FilterCompoents,
    FormAssocianteFaixaContribuicaoVue,
    FormAssociantePaymentConfigVue,
    AppCollapse,
    AppCollapseItem,
    BFormGroup,
    BFormInput,
    BFormSelectOption,
    BBadge
  },
  directives: { 'b-tooltip': VBTooltip },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('pagamentoRecebimentoFinancialModule', {
      comboSituacao: (state) => state.comboSituacao
    }),
    ...mapState('combosModule', {
      comboFormaPagamento: (state) => state.comboFormaPagamento,
      comboTipoPagamento: (state) => state.comboTipoPagamento,
      comboContas: (state) => state.comboContas
    }),
    ...mapState('associantesAdministrativeModule', {
      fullAssociante: (state) => state.fullAssociante
    }),
    direction() {
      return store.state.appConfig.isRTL
    }
  },
  async mounted() {
    this.isLoading = true
    await this.carregarTabela()
    this.isLoading = false
  },
  data() {
    const hoje = new Date()
    const primeiroDia = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
    const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0)
    const toInputDate = d => d.toISOString().split('T')[0]

    return {
      isLoading: false,
      showForm: false,
      listaFinanceira: [],
      totaisCards: { totalReceita: 0, totalDespesa: 0, saldoAtual: 0, totalPendente: 0 },
      currentPage: 1,
      tableConfigs: { totalElements: 0, totalPages: 0, size: 10 },
      pageConfig: { page: 1, size: 10, sort: 'dataVencimento', order: 'desc' },
      
      filter: {
        tipoTransacao: -1,
        situacao: -1,
        contaId: null,
        dataInicio: toInputDate(primeiroDia),
        dataFinal: toInputDate(ultimoDia),
        campo: '',
        tipoData: 'VENCIMENTO'
      },

      opcoestipoTransacao: [
        { value: -1, text: 'Todos' },
        { value: 0,  text: 'Contas a Pagar' },
        { value: 1,  text: 'Contas a Receber' }
      ],
      opcoesSituacao: [
        { value: -1,   text: 'Todas' },
        { value: 0,    text: 'Aberto' },
        { value: 1,    text: 'Vencido' },
        { value: 2,    text: 'Quitado' },
        { value: 3,    text: 'Cancelado' },
        { value: 4,    text: 'Pago a Menor' }
      ],
      opcoesTipoData: [
        { value: 'TODOS',      text: 'Vencimento ou Quitação' },
        { value: 'VENCIMENTO', text: 'Data de Vencimento' },
        { value: 'QUITACAO',   text: 'Data de Quitação' },
        { value: 'LANCAMENTO', text: 'Data de Lançamento' }
      ],

      columns: [
        { label: 'Situação',   field: 'situacao',       sortable: false },
        { label: 'Vencimento', field: 'dataVencimento', formatFn: this.formatDateGrid, sortable: true },
        { label: 'Descrição',  field: 'descricao',      sortable: false },
        { label: 'Natureza',   field: 'tipoBadge',      sortable: false },
        { label: 'Conta',      field: 'conta.descricao',sortable: false },
        { label: 'Valor Total',field: 'valorTotal',     sortable: false },
        { label: 'Ações',      field: 'action',         sortable: false }
      ],
      pageLength: 10,
      dir: false,
      objectFormInsert: {
        titleForm: 'Cadastro de Contas a Pagar / Receber'
      },
      objectAssociado: {
        registro: {
          id: null,
          nome: ''
        }
      }
    }
  },
  methods: {
    async carregarTotalizacao() {
      const filtroApi = this.montarFiltroApi()
      try {
        const result = await this.$store.dispatch('pagamentoRecebimentoFinancialModule/filterCards', filtroApi)
        if (result && result.data) {
          const d = result.data
          this.totaisCards = {
            totalReceita: d.totalReceitas || 0,
            totalDespesa: d.totalDespesas || 0,
            saldoAtual: d.saldoAtual || 0,
            totalPendente: d.totalPendente || 0
          }
        }
      } catch (err) {
        console.error('Erro ao buscar totais:', err)
      }
    },

    async carregarTabela() {
      this.isLoading = true
      const filtroApi = this.montarFiltroApi()
      try {
        const result = await this.$store.dispatch(
          'pagamentoRecebimentoFinancialModule/filterAllTransacoes',
          { filter: filtroApi, pageConfig: this.pageConfig }
        )
        if (result && result.data) {
          this.listaFinanceira = result.data.content
          this.tableConfigs.totalElements = result.data.totalElements
          this.tableConfigs.totalPages = result.data.totalPages
          this.tableConfigs.size = result.data.size
        }
      } catch (err) {
        this.MensagemError('Erro ao carregar transações', err.message)
      } finally {
        this.isLoading = false
      }
    },

    montarFiltroApi() {
      const fmtData = (d) => {
        if (!d) return null
        const parts = d.split('-')
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`
        return d
      }
      return {
        tipo: this.filter.tipoTransacao,
        dataInicio: fmtData(this.filter.dataInicio),
        dataFinal: fmtData(this.filter.dataFinal),
        situacao: this.filter.situacao,
        contaId: this.filter.contaId,
        campo: this.filter.campo || '',
        tipoData: this.filter.tipoData,
        registroId: this.$route.params.id || (this.fullAssociante ? this.fullAssociante.id : null)
      }
    },

    async aplicarFiltro() {
      this.currentPage = 1
      this.pageConfig.page = 1
      await Promise.all([this.carregarTotalizacao(), this.carregarTabela()])
    },

    handleSearch: _.debounce(function () {
      this.aplicarFiltro()
    }, 500),

    handleChangePage(page) {
      this.currentPage = page
      this.pageConfig.page = page
      this.carregarTabela()
    },

    onSortChange(params) {
      this.pageConfig.sort = params[0].field
      this.pageConfig.order = params[0].type
      this.carregarTabela()
    },

    getTipoBadgeVariant(row) {
      if (!row || !row.tipo) return 'light-secondary'
      if (row.tipo.tipoContabil) return row.tipo.tipoContabil === 'RECEITA' ? 'light-success' : 'light-danger'
      const nome = (row.tipo.nome || row.tipo.descricao || '').toUpperCase()
      if (nome.includes('RECEITA') || nome.includes('RECEB')) return 'light-success'
      if (nome.includes('DESPESA') || nome.includes('PAG')) return 'light-danger'
      return 'light-secondary'
    },
    getTipoLabel(row) {
      if (!row || !row.tipo) return '-'
      if (row.tipo.tipoContabil) return row.tipo.tipoContabil === 'RECEITA' ? 'Receita' : 'Despesa'
      const nome = (row.tipo.nome || row.tipo.descricao || '').toUpperCase()
      if (nome.includes('RECEITA') || nome.includes('RECEB')) return 'Receita'
      if (nome.includes('DESPESA') || nome.includes('PAG')) return 'Despesa'
      return row.tipo.nome || row.tipo.descricao || '-'
    },
    getSituacaoBadgeVariant(situacao) {
      const map = { ABERTO: 'light-info', VENCIDO: 'light-warning', QUITADO: 'light-success', PAGO_A_MENOR: 'light-primary', CANCELADO: 'light-secondary' }
      return map[situacao] || 'light-secondary'
    },
    getSituacaoLabel(situacao) {
      const map = { ABERTO: 'Aberto', VENCIDO: 'Vencido', QUITADO: 'Quitado', PAGO_A_MENOR: 'Pago a Menor', CANCELADO: 'Cancelado' }
      return map[situacao] || situacao || '-'
    },

    async add() {
      this.setDadosAssociado()
      await Promise.all([
        this.$store.dispatch('combosModule/loadComboFormaPagamento'),
        this.$store.dispatch('combosModule/loadComboTipoPagamento'),
        this.$store.dispatch('combosModule/loadComboContas')
      ])
      this.$store.dispatch('pagamentoRecebimentoFinancialModule/resetFinancialAccount')
      this.showForm = true
    },
    setDadosAssociado() {
      this.objectAssociado = {
        registro: { id: this.$route.params.id || this.fullAssociante.id, nome: this.fullAssociante ? this.fullAssociante.nome : '' }
      }
    },
    async editFinanceiro(data) {
      await Promise.all([
        this.$store.dispatch('combosModule/loadComboFormaPagamento'),
        this.$store.dispatch('combosModule/loadComboTipoPagamento'),
        this.$store.dispatch('combosModule/loadComboContas')
      ])
      this.objectAssociado = this.prepareEditObject(data)
      this.showForm = true
    },
    prepareEditObject(data) {
      return {
        id: data.id,
        registro: { id: this.$route.params.id || this.fullAssociante.id, nome: this.fullAssociante ? this.fullAssociante.nome : '' },
        descricao: data.descricao,
        dataLancamento: data.dataLancamento,
        dataVencimento: data.dataVencimento,
        dataQuitacao: data.dataQuitacao,
        valor: data.valor,
        desconto: data.desconto,
        juro: data.juro,
        multa: data.multa,
        valorTotal: data.valorTotal,
        valorQuitado: data.valorQuitado,
        observacao: data.observacao,
        tipo: { id: data.tipo.id, nome: data.tipo.descricao },
        formaPagamento: { id: data.formaPagamento.id, nome: data.formaPagamento.descricao },
        conta: data.conta ? data.conta.id : null,
        situacao: data.situacao,
        ativo: data.ativo,
        qtoRepetido: data.qtoRepetido
      }
    },
    async save(data) {
      const payload = this.prepareForSave(data)
      const action = payload.id ? 'editPagamentoRecebimento' : 'insertNewPagamentoRecebimento'
      const response = await this.$store.dispatch(`pagamentoRecebimentoFinancialModule/${action}`, payload)
      if (response && response.response && response.response.data) {
        this.MensagemError('Erro', response.response.data.message)
        return
      }
      this.showMessageSuccess('Sucesso', 'Salvo com sucesso!')
      this.cancelar()
    },
    cancelar() {
      this.showForm = false
      this.aplicarFiltro()
    },
    prepareForSave(data) {
      const obj = JSON.parse(JSON.stringify(data))
      return {
        ...obj,
        tipo: obj.tipo.id ? obj.tipo : { id: obj.tipo },
        formaPagamento: obj.formaPagamento.id ? obj.formaPagamento : { id: obj.formaPagamento },
        conta: obj.conta ? (obj.conta.id ? obj.conta : { id: obj.conta }) : null
      }
    },
    async remove(data) {
      this.$swal({
        title: 'Remover?',
        text: 'Ação irreversível',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Remover',
        customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch('pagamentoRecebimentoFinancialModule/delete', data.id)
          this.showMessageSuccess('Sucesso', 'Removido!')
          this.aplicarFiltro()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.font-medium-3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
}

.card {
  border-radius: 0.75rem;
}

::v-deep .vgt-table {
  border: none !important;
  th {
    background-color: #f8f9fa !important;
    color: #6e6b7b !important;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.85rem;
    padding: 1rem 0.5rem !important;
  }
  td {
    padding: 0.8rem 0.5rem !important;
    vertical-align: middle;
  }
}

.btn-icon-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.2rem;
  font-weight: 500;
  border-radius: 0.5rem;
}

::v-deep .collapse-icon {
  .card {
    border: 1px solid #ebe9f1;
    box-shadow: none !important;
    margin-bottom: 0.5rem;
  }
  .card-header {
    padding: 0.8rem 1rem;
    background-color: #f8f9fa;
  }
}
</style>
